






































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { Webinar as IWebinar } from "@/api/models/webinar";
import HomeWebinarTables from "@/components/home-page/HomeWebinarTables.vue";

@Component({
  components: { CustomButton, CustomTable, HomeWebinarTables }
})
export default class WebinarsTimetable extends Vue {
  @Prop() webinars!: Array<IWebinar>;
  accessTokenProd!: any;
  accessTokenDev!: any;

  data() {
    return {
      currentAccessToken: undefined,
      accessTokenProd: null,
      accessTokenDev: null
    };
  }

  getAccessToken() {
    this.accessTokenDev = localStorage.getItem("auth-tokens-development");
    this.accessTokenProd = localStorage.getItem("auth-tokens-production");

    this.accessTokenProd
      ? (this.accessTokenProd = JSON.parse(this.accessTokenProd))
      : (this.accessTokenDev = JSON.parse(this.accessTokenDev));
  }

  mounted() {
    this.getAccessToken();
  }
}
